<script>
import Vue from "vue";
import Base from "@backend/Base.vue";
import BOGen from "@helper/BOGen.js";

Vue.component("WorkingFacility", () =>
  import("@backend/WorkingFacilityInbox.vue")
);

export default {
  extends: Base,
  data() {
    return {
      Name: "AdditionalFacilityInit",
      PageName: "Additional Facility Request",
      ObjectName: "Additional Facility Request",
      NoList: true,
      mrRequestFor: [],
      tab: "current",
      mfsData: [],
      WF: {},
      WFcurrent: {},
      allFs: [],
      row: { aa: {}, aal: {} },
      emp: {},
      input: { mrf_id: "", ai_employee_id: 0, type: "S" },
      mrValidation: {
        mrf_id: "required",
        ai_employee_id: "required",
        ai_return_date: "required",
      },
      notRefreshData: false,
      counter: 1,
      employeesGroup: [],
      error: { show: false, message: "" },
      optionUsers: [],
      currentFacility: {},
      notificationLink: {}
    };
  },
  computed: {
    self() {
      return this;
    },
    mrf() {
      return (
        this.mrRequestFor.filter((x) => {
          return x.mrf_id == this.input.mrf_id;
        })[0] || { mrf_name: "Additional Facility" }
      );
    },
  },
  mounted() {
    // this.checkAccessMenu(this.$route.meta.group)

    this.$set(this.$root, "page", this);
    if (this.$route.name == "AdditionalFacilityApproval") {
      this.PageName = "Additional Facility Approval";
    }
    this.apiMrRequestFor();
    if (this.$route.params.id) {
      this.refreshData();

      setTimeout(() => {
        this.checkLinkApproval();
      }, 1000);
    }
  },
  methods: {
    refreshData(fromButton = false, allUser = false) {
      if (
        (this.input.type == "S" && !fromButton) ||
        (this.input.type == "B" && fromButton)
      )
        this.loadingOverlay = true;
      var params = !allUser
        ? {
            id: +this.input.ai_employee_id,
            type: this.input.type,
            mrf_id: this.input.mrf_id,
          }
        : {
            id: this.optionUsers[0].id,
            type: this.input.type,
            mrf_id: this.input.mrf_id,
          };
      if (this.$route.name == "AdditionalFacilityApproval") {
        params = { request_number: this.$route.params.id };
      }
      if (allUser) {
        this.employeesGroup = this.optionUsers;
      }
      BOGen.apirest(
        "/WorkingFacility",
        params,
        (err, resp) => {
          this.loadingOverlay = false;
          if (err) return console.error(err);
          Object.keys(resp).forEach((k) => {
            this[k] = resp[k];
          });
          if (fromButton) {
            if (!allUser) {
              this.$set(this.input, "ai_employee_id", null);
              const existEmployee = this.employeesGroup.find(
                (emp) => emp.cwid == resp.emp.cwid
              );

              if (existEmployee) {
                this.error = {
                  show: true,
                  message: "Employee Already Exist",
                };

                setTimeout(() => {
                  this.error = {
                    show: false,
                    message: "",
                  };
                }, 2000);
              } else {
                // resp.emp['req_number'] = resp.row.request_number.split('-')[0] + '-' + resp.row.request_number.split('-')[1] + '-' + number.toLocaleString('en-US', { minimumIntegerDigits: 5, useGrouping: false })
                this.employeesGroup.push(resp.emp);

                this.employeesGroup = this.employeesGroup.map((v, k) => {
                  let number = +resp.row.request_number.split("-")[2] + (k + 1);
                  return {
                    ...v,
                    req_number:
                      resp.row.request_number.split("-")[0] +
                      "-" +
                      resp.row.request_number.split("-")[1] +
                      "-" +
                      number.toLocaleString("en-US", {
                        minimumIntegerDigits: 5,
                        useGrouping: false,
                      }),
                  };
                });
              }
            }
          }
          if (this.row.ai_type == "additional-facility")
            this.input.mrf_id = this.row.ai_mrf_id;
          if (this.WF.setParent) this.WF.setParent();
          if (this.WFcurrent.setParent) this.WFcurrent.setParent();

          if (this.$route.params.id) {
            setTimeout(() => {
              this.setCurrentFacilty(
                this.row.ai_employee_id,
                this.row.ai_request_number
              );
            }, 1500);
          }
        },
        "POST"
      );
    },
    apiMrRequestFor() {
      BOGen.apirest(
        "/request-for-select",
        { type: "additional-facility" },
        (e, resp) => {
          if (e) return console.error(e);
          this.mrRequestFor = resp.data.sort((a, b) => {
            let fa = a.mrf_name.toLowerCase(),
              fb = b.mrf_name.toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          });
        }
      );
    },
    resultDataEmployee(data) {
      var items = [];
      data.data.forEach((x) => {
        items.push({
          id: x.id,
          cwid: x.cwid,
          text:
            (x.cwid ? x.cwid + " | " : "") +
            x.employeename +
            " " +
            (x.position ? "(" + x.position + ")" : ""),
        });
      });
      return { results: items };
    },
    checkAttachment() {
      const fsAttachments = Object.values(this.WF.fs)
        .map((obj) => obj.afs_attachment)
        .flat(Infinity);
      const fsAnswers = Object.values(this.WF.fs)
        .map((obj) =>
          obj.afs_type == "checkbox_title"
            ? obj.afs_answer.map((ans) => ans.options)
            : obj.afs_answer
        )
        .flat(Infinity);

      const checkFileAttachment = fsAttachments.filter(
        (attachment) =>
          fsAnswers.includes(attachment.name) && attachment.file == ""
      );

      return checkFileAttachment.length > 0 ? true : false;
    },
    addAllUsers() {
      BOGen.apirest(
        "/employees-select?havecwid=true&bg_id=" +
          (this.input.mrf_id == 24 ? 0 : this.user.emp.bg_id) +
          "&mrf_id=" +
          this.input.mrf_id +
          "&msg_id=" +
          this.user.emp.msg_id +
          "&isAdmin=" +
          (this.user.emp.access_level == 1 ? true : false) +
          "&user=" +
          this.user.emp.cwid +
          "&onlyEmployee=true&type=additional-facility" +
          "",
        {},
        (err, resp) => {
          if (err) console.error(err);

          const data = resp.data;

          this.optionUsers = data.map((x) => {
            return {
              id: x.id,
              cwid: x.cwid,
              IPIN: x.ipin,
              costcenter: x.mcc_costcenter,
              department: x.msg_name,
              employeename: x.employeename,
            };
          });

          this.refreshData(true, true);
        }
      );
    },
    fsDiff() {
      return BOGen.fsDiff(this, this.WFcurrent.fs, this.WF.fs);
    },
    checkLinkApproval() {
      if (this.$route.name == "AdditionalFacilityApproval") {
        if (
          (this.row.ai_status == "APA" ||
            this.row.ai_status == "MNG" ||
            this.row.ai_status == "ADC") &&
          this.user.al_name == "Employee"
        ) {
          return this.$router.push({ name: "Dashboard" });
        }

        // if (this.row.ai_status == "MNG" && this.user.al_name != "Manager") {
        //   return this.$router.push({ name: "Dashboard" });
        // }

        if (
          this.row.ai_status == "MNG" &&
          this.row.aa.aa_manager_cwid != this.user.cwid 
          // && this.user.al_name == "Manager"
        ) {
          return this.$router.push({ name: "Dashboard" });
        }

        if (this.row.ai_status == "APA" && !this.isServicesRole) {
          return this.$router.push({ name: "Dashboard" });
        }

        if (
          this.row.ai_status == "SPV" &&
          this.row.ai_created_by != this.user.cwid
        ) {
          return this.$router.push({ name: "Dashboard" });
        }
      }
    },
    submitForm(e) {
      swal({
        title: "Are you sure to submit?",
        text: "",
        icon: "warning",
        buttons: ["No, Cancel!", "Yes, Sure!"],
        // dangerMode: true,
      }).then((ok) => {
        if (!ok) return;
        if (this.loadingOverlay) return;
        this.loadingOverlay = true;

        var fs = [];
        Object.keys(this.WF.fs).forEach((v) => {
          var afs = Gen.clone(this.WF.fs[v]);
          afs.afs_answer = JSON.stringify(afs.afs_answer);
          fs.push(afs);
        });
        if (this.$route.name == "AdditionalFacilityInit") {
          const fsAttachments = Object.values(this.WF.fs)
            .map((obj) => obj.afs_attachment.map((att) => att.name))
            .flat(Infinity);
          const fsAnswers = Object.values(this.WF.fs)
            .map((obj) =>
              obj.afs_type == "checkbox_title"
                ? obj.afs_answer.map((ans) => ans.options)
                : obj.afs_answer
            )
            .flat(Infinity);
          const answerSelected = fsAnswers.map((option) =>
            fsAttachments.indexOf(option) >= 0 ? true : false
          );
          this.input.ai_request_number = this.row.request_number;
          if (this.input.type == "S") this.input.fsDiff = this.fsDiff();
          this.input.workingFacilitiesActive = this.WF.workingFacilitiesActive();
          this.input.filteredWorkingFacilitiesActive = this.WF.workingFacilitiesActive()
            .filter((d) => d.active)
            .map((v) => v.module);
          this.input.init_type = this.input.type;
          this.input.using_attachment =
            answerSelected.indexOf(true) >= 0 ? true : false;

          // Belum ada validasi kalau attachment nya belum diisi

          if (this.input.type == "B")
            this.input.employeesGroup = this.employeesGroup;
          if (this.input.ai_return_date)
            this.input.ai_return_date = this.input.ai_return_date
              .split("-")
              .reverse()
              .join("-");

          BOGen.apirest(
            "/AdditionalFacility",
            Object.assign(this.input, { fs: fs }),
            (err, resp) => {
              this.loadingOverlay = false;
              if (err) {
                swal(err.json.message, "", "warning").then(() => {
                  $("body,html").animate({ scrollTop: 0 }, 300);
                });

                return console.error(err);
              }

              swal("Data has been submitted", "", "success").then(() => {
                this.$router.push({ name: "AdditionalFacility" });
                this.input = {};
                $("body,html").animate({ scrollTop: 0 }, 300);
              });
            },
            "POST"
          );
        } else if (
          this.$route.name == "AdditionalFacilityApproval" &&
          this.row.ai_status == "MNG"
        ) {          
          this.input.request_number = this.row.ai_request_number;
          this.input.workingFacilitiesActive = this.WF.workingFacilitiesActive();
          this.input.filteredWorkingFacilitiesActive = this.WF.workingFacilitiesActive()
            .filter((d) => d.active)
            .map((v) => v.module);
          this.input.employeesGroup = this.childGroup;
          this.input.fsDiff = this.fsDiff();
          BOGen.apirest(
            "/AdditionalFacilityApproval",
            Object.assign(this.input, { fs: fs }),
            (err, resp) => {
              this.loadingOverlay = false;
              if (err) return console.error(err);

              swal("Data has been submitted", "", "success").then(() => {
                this.$router.push({ name: "Inbox" });
                this.input = {};
                $("body,html").animate({ scrollTop: 0 }, 300);
              });
            },
            "POST"
          );
        } else if (
          this.$route.name == "AdditionalFacilityApproval" &&
          this.row.ai_status == "ADC"
        ) {          
          this.input.request_number = this.row.ai_request_number;
          this.input.workingFacilitiesActive = this.WF.workingFacilitiesActive();
          this.input.filteredWorkingFacilitiesActive = this.WF.workingFacilitiesActive()
            .filter((d) => d.active)
            .map((v) => v.module);
          this.input.employeesGroup = this.childGroup;
          this.input.fsDiff = this.fsDiff();
          BOGen.apirest(
            "/AttachmentAFApproval",
            Object.assign(this.input, { fs: fs }),
            (err, resp) => {
              this.loadingOverlay = false;
              if (err) return console.error(err);

              swal("Data has been submitted", "", "success").then(() => {
                this.$router.push({ name: "Inbox" });
                this.input = {};
                $("body,html").animate({ scrollTop: 0 }, 300);
              });
            },
            "POST"
          );
        } else if (
          this.$route.name == "AdditionalFacilityApproval" &&
          this.row.ai_status == "APA"
        ) {          
          // Confirmation Admin IT / GA
          this.input.request_number = this.row.ai_request_number;
          this.input.workingFacilitiesActive = this.WF.workingFacilitiesActive();
          this.input.filteredWorkingFacilitiesActive = this.WF.workingFacilitiesActive()
            .filter((d) => d.active)
            .map((v) => v.module);
          this.input.fsDiff = this.fsDiff();
          this.input.employeesGroup = this.childGroup;
          this.input.remarks =
            this.input.status == "A"
              ? `Confirmed by ${
                  this.user.al_access_module.indexOf("ITServices") > -1
                    ? "Admin IT"
                    : "Admin GA"
                }`
              : this.input.remarks;
                    

          let fsParam = this.row.ai_mrf_id == 24
           ? fs.map(facility => {
            const findFacility = this.allFs.find(afs => {
              return afs.afs_employee_id == facility.afs_employee_id && afs.afs_mfs_id == facility.afs_mfs_id
            })
            const facilityAnswer = typeof facility.afs_answer == "string" ? JSON.parse(facility.afs_answer) : facility.afs_answer            
            if(!findFacility) return {...facility, afs_answer: facilityAnswer}            
            if(findFacility.facility_type == 'checkbox'){
              return {
                ...facility, 
                afs_id: findFacility.afs_id,
                afs_answer: findFacility.afs_answer.filter(ff => facilityAnswer.indexOf(ff) < 0)
              }
            } else if(findFacility.facility_type == 'checkbox_title'){
              return {
                ...facility, 
                afs_id: findFacility.afs_id,                
                afs_answer: findFacility.afs_answer.map(ff => {
                  const findObj = facilityAnswer.find(fa => fa.title == ff.title) // Find Option With same name                  
                  if(findObj && findObj.options){
                    const options = ff.options.filter(ffo => {
                      return findObj.options.indexOf(ffo) < 0
                    })
                    return {...ff, options}
                  } else {
                    return {...ff}
                  }
                })
              }
            }
           }).filter(f => f.afs_id)
           : fs;

          BOGen.apirest(
            "/FacilityConfirmationAdmin",
            Object.assign(this.input, { fs: fsParam }),
            (err, resp) => {
              this.loadingOverlay = false;
              if (err) return console.error(err);

              swal("Data has been submitted", "", "success").then(() => {
                this.$router.push({ name: "Inbox" });
                this.input = {};
                $("body,html").animate({ scrollTop: 0 }, 300);
              });
            },
            "POST"
          );
        }
      });
    },
    removeFromGroup(index) {
      this.employeesGroup = this.employeesGroup
        .filter((emp, key) => key != index)
        .map((v, k) => {
          let number = +this.row.request_number.split("-")[2] + (k + 1);
          return {
            ...v,
            req_number:
              this.row.request_number.split("-")[0] +
              "-" +
              this.row.request_number.split("-")[1] +
              "-" +
              number.toLocaleString("en-US", {
                minimumIntegerDigits: 5,
                useGrouping: false,
              }),
          };
        });
    },
    checkCWIDBulk() {
      if (this.input.type == "B" && this.employeesGroup.length) {
        this.$set(this, "notRefreshData", true);
        this.$set(
          this.input,
          "ai_employee_id",
          this.employeesGroup[this.employeesGroup.length - 1].id
        );

        setTimeout(() => {
          this.$set(this, "notRefreshData", false);
        }, 1000);
      }
    },
    arrayUniqueByKey(array, key){
      return [...new Map(array.map(item =>
        [item[key], item])).values()]
    },

    setCurrentFacilty(v, reqId = null) {
      const allFS = reqId
        ? this.allFs.filter(
            (af) => af.afs_employee_id == v && af.afs_request_number != reqId
          )
        : this.allFs.filter((af) => af.afs_employee_id == v)

      const filteredFs = this.arrayUniqueByKey(allFS, 'afs_mfs_id')
      const tempCurrentFacility = []

      filteredFs.forEach((ffs) => {
        const checkIndexFs = tempCurrentFacility.findIndex(
          (tcf) => tcf.afs_mfs_id == ffs.afs_mfs_id
        );

        if (checkIndexFs < 0) {
          tempCurrentFacility.push(ffs);
        } else {
          const typeFs = tempCurrentFacility[checkIndexFs]["afs_answer"].map(
            (x) => typeof x
          )[0];

          if (typeFs == "object") {
            const resultAnswers = [];
            tempCurrentFacility[checkIndexFs].afs_answer.forEach((x) => {
              const options = ffs.afs_answer.find(
                (ans) => ans.title == x.title
              );

              if (options)
                resultAnswers.push({
                  ...x,
                  options: [...x.options, ...options.options].filter(
                    this.onlyUnique
                  ),
                });
            });
            tempCurrentFacility[checkIndexFs]["afs_answer"] = resultAnswers;
          } else {
            tempCurrentFacility[checkIndexFs]["afs_answer"] = [
              ...tempCurrentFacility[checkIndexFs]["afs_answer"],
              ...ffs.afs_answer,
            ];
          }
        }
      });

      if (this.input.mrf_id == 24) {
        // const objFS = {}
        // this.fs.forEach(f => {
        //   objFS[f.afs_mfs_id] = f
        // })

        // this.$set(this, "currentFacility", objFS);        
        this.$set(
          this,
          "currentFacility",
          Object.assign(
            {},
            ...[... new Set(tempCurrentFacility.map(JSON.stringify))].map(JSON.parse).map((x) => ({ [x.afs_mfs_id]: x }))
          )
        );
      } else {
        this.$set(
          this,
          "currentFacility",
          Object.assign(
            {},
            ...[... new Set(tempCurrentFacility.map(JSON.stringify))].map((x) => ({ [x.afs_mfs_id]: x }))
          )
        );
      }
    },

    setDefaultAccessDoor(){
      const findFacilityAccess = this.mfsData.find(md => md.mfs_name.includes("Access"))
      // if(findFacilityAccess){
      //   const {
      //     mfs_id, mfs_facility_need_attachment, mfs_type,
      //     mfs_values
      //   } = findFacilityAccess

      //   const newValues = mfs_values.map(value => {
      //     if(value.title.includes("Access Door")) return { ...value, options: this.row.default_access_door, ya: true }
      //     return { ...value, options: [] }
      //   })

      //   this.$set(this, 'fs', {
      //     [mfs_id]: {
      //       afs_mfs_id: mfs_id,
      //       afs_answer: newValues,
      //       afs_remarks:"",
      //       afs_id: null,
      //       afs_attachment: mfs_facility_need_attachment ? mfs_facility_need_attachment.map(facility => ({name: facility, file: ""})) : [],
      //       afs_type: mfs_type
      //     }
      //   })
      // }
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
  },
  watch: {
    "input.mrf_id"(v) {
      if (v == 24 && this.WF.workingFacilities) {
        Object.keys(this.WF.workingFacilities()).forEach((id) => {
          if (this.WF.wfActive(id)) this.WF.tabs.id = id;
        });
      }
      if (this.WF.setFS) this.WF.setFS();

      if (v != 23) {
        this.$set(this.input, "type", "S");
      }

      if (v == 32) {
        this.$set(this.input, "type", "B");
      }

      this.$set(this, "employeesGroup", []);
    },
    "input.ai_employee_id"(v) {
      if (!v) return;
      if (!this.notRefreshData) this.refreshData();

      this.$set(this, "currentFacilty", {});

      setTimeout(() => {
        this.setCurrentFacilty(v);
      }, 1200);
    },
    "input.type"(v) {
      if (v == "B") this.$set(this, "tab", "current");
      this.$set(this.input, "ai_employee_id", null);
    },

    "row.default_access_door"(v){
      if(v.length > 0){
        setTimeout(() => {           
          this.setDefaultAccessDoor()
        }, 1000)
      }
    }
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row page-titles align-items-center">
      <div class="col-md-5">
        <h4 class="text-themecolor">{{ PageName }}</h4>
      </div>
      <div class="col-md-7 tr">
        <div class="btn-group">
          <router-link
            :to="{ name: 'AdditionalFacility' }"
            class="btn btn-outline-info"
            v-tooltip="'List ' + ObjectName"
          >
            <i class="fa fa-list"></i><span> List</span>
          </router-link>
        </div>
      </div>
    </div>

    <VForm @resp="submitForm" method="post">
      <div class="card" v-if="$route.name == 'AdditionalFacilityInit'">
        <div class="card-header bg-info">
          <h4 class="m-b-0 text-white">Facility Set Up</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-9">
              <div class="row">
                <div
                  class="col-md-3"
                  v-if="!input.mrf_id || input.mrf_id == 23"
                >
                  <bo-field label="Type">
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        type="radio"
                        id="defSingle"
                        class="custom-control-input"
                        value="S"
                        v-model="input.type"
                      />
                      <label class="custom-control-label" for="defSingle"
                        >Single
                      </label>
                    </div>
                    <div
                      class="custom-control custom-radio custom-control-inline"
                      v-if="
                        ['Administrator', 'Supervisor', 'Manager'].indexOf(
                          user.al_name
                        ) > -1
                      "
                    >
                      <input
                        type="radio"
                        id="defBulk"
                        class="custom-control-input"
                        value="B"
                        v-model="input.type"
                      />
                      <label class="custom-control-label" for="defBulk"
                        >Bulk
                      </label>
                    </div>
                  </bo-field>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <b>AF No</b>
                    <p>
                      <span
                        class="label label-table label-success"
                        v-if="row.request_number"
                        >{{ row.ai_request_number || row.request_number }}</span
                      ><span v-else>-</span>
                    </p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <b>Request Date</b>
                    <p>{{ "now".dates("format2") }}</p>
                  </div>
                </div>
                <div
                  class="col-md-3"
                  v-if="
                    input.mrf_id && input.mrf_id != 23 && input.mrf_id != 32
                  "
                >
                  <div class="form-group">
                    <b>Return Date <span class="text-danger">*</span></b>
                    <DatePicker
                      name="ai_return_date"
                      v-model="input.ai_return_date"
                      v-bind="validation('ai_return_date')"
                      :disabledYesterday="true"
                    ></DatePicker>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <BoField name="mrf_id">
                    <b slot="label"
                      >{{ fields.mrf_id }} <span class="text-danger">*</span></b
                    >
                    <Select2
                      name="mrf_id"
                      :options="mrRequestFor"
                      :object="['mrf_id', 'mrf_name']"
                      v-model="input.mrf_id"
                      v-bind="validation('mrf_id')"
                      v-if="$route.name == 'AdditionalFacilityInit'"
                    >
                      <option value="">-- Select Request For --</option>
                    </Select2>
                    <span v-else>{{ row.request_for }}</span>
                  </BoField>
                </div>
                <div class="col-md-5">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <BoField
                      name="ai_employee_id"
                      :style="input.type == 'S' ? 'width:100%;' : 'width:65%;'"
                    >
                      <b slot="label"
                        >{{ fields.ai_employee_id }}
                        <span class="text-danger">*</span></b
                      >
                      <template v-if="$route.name == 'AdditionalFacilityInit'">
                        <Select2Ajax
                          :url="
                            '/api/employees-select?havecwid=true&bg_id=' +
                              (input.mrf_id == 24 ? 0 : user.emp.bg_id) +
                              '&mrf_id=' +
                              input.mrf_id +
                              '&msg_id=' +
                              user.emp.msg_id +
                              '&isAdmin=' +
                              (user.emp.access_level == 1 ? true : false) +
                              '&user=' +
                              user.emp.cwid +
                              '&onlyEmployee=true&type=additional-facility'
                          "
                          name="ai_employee_id"
                          v-model="input.ai_employee_id"
                          :resultData="resultDataEmployee"
                          placeholder="-- Select Employee --"
                          v-if="input.type == 'B'"
                        ></Select2Ajax>
                        <Select2Ajax
                          :url="
                            '/api/employees-select?havecwid=true&bg_id=' +
                              (input.mrf_id == 24 ? 0 : user.emp.bg_id) +
                              '&mrf_id=' +
                              input.mrf_id +
                              '&msg_id=' +
                              user.emp.msg_id +
                              '&isAdmin=' +
                              (user.emp.access_level == 1 ? true : false) +
                              '&user=' +
                              user.emp.cwid +
                              '&onlyEmployee=true&type=additional-facility'
                          "
                          name="ai_employee_id"
                          v-model="input.ai_employee_id"
                          v-bind="validation('ai_employee_id')"
                          :resultData="resultDataEmployee"
                          placeholder="-- Select Employee --"
                          v-if="input.type == 'S'"
                        ></Select2Ajax>
                      </template>
                      <span v-else>{{ emp.employeename }}</span>
                    </BoField>

                    <button
                      @click="refreshData(true)"
                      type="button"
                      class="btn btn-outline-success"
                      v-if="input.type == 'B'"
                      :disabled="!input.ai_employee_id"
                      :style="
                        input.type == 'B' ? 'transform: translateX(1.5em);' : ''
                      "
                    >
                      <i class="fa fa-plus"></i> Add This User
                    </button>
                    <button
                      @click="addAllUsers"
                      type="button"
                      class="btn btn-outline-success ml-2"
                      v-if="input.type == 'B' && input.mrf_id == 32"
                      :style="
                        input.type == 'B' ? 'transform: translateX(1.5em);' : ''
                      "
                    >
                      <i class="fa fa-plus"></i> Add All User
                    </button>
                  </div>
                </div>
                <div class="col-md-2" v-if="input.type != 'B'">
                  <div class="form-group">
                    <b>IPIN</b>
                    <p>{{ emp.IPIN || "-" }}</p>
                  </div>
                </div>
                <div class="col-md-2" v-if="input.type != 'B'">
                  <div class="form-group">
                    <b>CWID</b>
                    <p>{{ emp.cwid || "-" }}</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3" v-if="input.type != 'B'">
                  <div class="form-group">
                    <b>Division</b>
                    <p>{{ emp.division || "-" }}</p>
                  </div>
                </div>
                <div class="col-md-3" v-if="input.type != 'B'">
                  <div class="form-group">
                    <b>Department</b>
                    <p>{{ emp.department || "-" }}</p>
                  </div>
                </div>
                <div class="col-md-3" v-if="input.type != 'B'">
                  <div class="form-group">
                    <b>Position</b>
                    <p>{{ emp.position || "-" }}</p>
                  </div>
                </div>
                <div class="col-md-3" v-if="input.type != 'B'">
                  <div class="form-group">
                    <b>Cost Center SAP</b>
                    <p>{{ emp.costcenter || "-" }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-md-12 mt-4"
              v-if="
                input.type && input.type == 'B' && employeesGroup.length > 0
              "
            >
              <div class="alert alert-danger" v-if="error.show">
                <button type="button" class="close" data-dismiss="alert">
                  <span>&times;</span><span class="sr-only">Close</span>
                </button>

                {{ error.message }}
              </div>
              <table
                class="table table-striped table-hover table-bordered mb-0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Employee Name</th>
                    <th>IPIN</th>
                    <th>CWID</th>
                    <th>Department</th>
                    <th>Cost Senter SAP</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(employee, k) in employeesGroup" :key="k">
                    <td>{{ k + 1 }}</td>
                    <td>{{ employee.employeename || "-" }}</td>
                    <td>{{ employee.IPIN || "-" }}</td>
                    <td>{{ employee.cwid || "-" }}</td>
                    <td>{{ employee.department || "-" }}</td>
                    <td>{{ employee.costcenter || "-" }}</td>
                    <td class="btn-action">
                      <a
                        href="javascript:;"
                        class="icon_action"
                        v-tooltip="'Remove From Group'"
                        @click="removeFromGroup(k)"
                        ><i class="icon-trash"></i
                      ></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <ul class="nav nav-tabs" v-if="mfsData.length">
        <li class="nav-item">
          <a
            href="javascript:;"
            class="nav-link tabs-link"
            :class="{ active: tab == 'current' }"
            @click="tab = 'current'"
            >{{ mrf.mrf_name }} Request</a
          >
        </li>
        <li class="nav-item" v-if="input.type != 'B'">
          <a
            href="javascript:;"
            class="nav-link tabs-link"
            :class="{ active: tab == 'old' }"
            @click="tab = 'old'"
            >Current Facility</a
          >
        </li>
      </ul>

      <div class="card" v-if="$route.name == 'AdditionalFacilityApproval'">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="row row-gutter">
                <div class="col-md-4">
                  <div class="detail-info">
                    <strong>AF No.</strong>
                    <span v-if="row.request_number">{{
                      row.ai_request_number || row.request_number
                    }}</span
                    ><span v-else>-</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="detail-info">
                    <strong>Request Date</strong>
                    <span>{{
                      row.ai_created_at && row.ai_created_at.dates("format2")
                    }}</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="detail-info">
                    <strong>Request For</strong>
                    <span>{{ row.request_for }}</span>
                  </div>
                </div>
                <div class="col-md-4" v-if="row.ai_mrf_id != 23">
                  <div class="detail-info">
                    <strong>Return Date</strong>
                    <span>{{
                      row.ai_return_date && row.ai_return_date.dates("format")
                    }}</span>
                  </div>
                </div>
                <template v-if="!row.ai_root_group">
                  <div class="col-md-4">
                    <div class="detail-info">
                      <strong>Employee Name</strong>
                      <span>{{ emp.employeename }}</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="detail-info">
                      <strong>IPIN</strong>
                      <span>{{ emp.IPIN || "-" }}</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="detail-info">
                      <strong>CWID</strong>
                      <span>{{ emp.cwid || "-" }}</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="detail-info">
                      <strong>Division</strong>
                      <span>{{ emp.division || "-" }}</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="detail-info">
                      <strong>Department</strong>
                      <span>{{ emp.department || "-" }}</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="detail-info">
                      <strong>Position</strong>
                      <span>{{ emp.position || "-" }}</span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="detail-info">
                      <strong>Cost Center SAP</strong>
                      <span>{{ emp.costcenter || "-" }}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <template v-if="row.ai_root_group">
              <div class="col-md-12 mt-4">
                <table
                  class="table table-striped table-hover table-bordered mb-0"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Employee Name</th>
                      <th>IPIN</th>
                      <th>CWID</th>
                      <th>Department</th>
                      <th>Cost Senter SAP</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(employee, k) in childGroup" :key="k">
                      <td>{{ k + 1 }}</td>
                      <td>{{ employee.employeename || "-" }}</td>
                      <td>{{ employee.ai_ipin || "-" }}</td>
                      <td>{{ employee.ai_cwid || "-" }}</td>
                      <td>{{ employee.department || "-" }}</td>
                      <td>{{ employee.costcenter || "-" }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
        </div>
      </div>
      <template v-if="input.mrf_id == 24">
        <WorkingFacility
          v-if="mfsData.length"
          v-show="tab == 'current'"
          :parent="self"
          @init="(comp) => (WF = comp)"
          :request="true"
          :parentTab.sync="tab"
          :cf.sync="currentFacility"
        ></WorkingFacility>
      </template>
      <template v-else>
        <WorkingFacility
          v-if="mfsData.length"
          v-show="tab == 'current'"
          :parent="self"
          @init="(comp) => (WF = comp)"
          :request="true"
          :parentTab.sync="tab"
          :cf.sync="currentFacility"
        ></WorkingFacility>
      </template>
      <WorkingFacility
        v-if="mfsData.length && input.type != 'B'"
        v-show="tab == 'old'"
        :parent="self"
        @init="(comp) => (WFcurrent = comp)"
        :parentTab.sync="tab"
        :cf.sync="currentFacility"
      ></WorkingFacility>

      <div class="card" v-if="$route.name == 'AdditionalFacilityInit'">
        <div class="card-body">
          <div class="form-actions text-right">
            <button
              type="submit"
              class="btn btn-info mr10 btn-loading"
              :disabled="
                !WF.isFilled ||
                  (input.type == 'B' && employeesGroup.length < 1) ||
                  checkAttachment()
              "
              @click="checkCWIDBulk"
            >
              Submit Form
            </button>
          </div>
        </div>
      </div>
      <div
        class="card"
        v-if="
          $route.name == 'AdditionalFacilityApproval' &&
            (row.ai_status == 'MNG' ||
              row.ai_status == 'APA' ||
              row.ai_status == 'ADC')
        "
      >
        <div class="card-header">
          <h5 class="card-title mb-0">Approval</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <bo-field
                :label="
                  row.ai_status == 'ADC'
                    ? 'Attachment Approval'
                    : 'Additional Facility Approval'
                "
                mandatory
              >
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="defAppr"
                    class="custom-control-input"
                    value="A"
                    v-model="input.status"
                  />
                  <label class="custom-control-label" for="defAppr"
                    >Approve
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="defRej"
                    class="custom-control-input"
                    value="R"
                    v-model="input.status"
                  />
                  <label class="custom-control-label" for="defRej"
                    >Reject
                  </label>
                </div>
              </bo-field>
            </div>
            <div class="col-md-6" v-if="input.status == 'R'">
              <bo-field label="Rejection Notes">
                <textarea
                  v-model="input.remarks"
                  minlength="3"
                  class="form-control"
                  rows="5"
                  required
                ></textarea>
              </bo-field>
            </div>
            <div class="col-12 text-right">
              <button
                type="button"
                @click="$router.push({ name: 'Inbox' })"
                class="btn btn-default mr5"
              >
                Cancel
              </button>
              <button
                class="btn btn-info"
                type="submit"
                :disabled="!input.status"
              >
                Submit Approval
              </button>
            </div>
          </div>
        </div>
      </div>
    </VForm>
  </div>
</template>
